import { render, staticRenderFns } from "./NeedHelp.vue?vue&type=template&id=f25c2844"
import script from "./NeedHelp.vue?vue&type=script&lang=js"
export * from "./NeedHelp.vue?vue&type=script&lang=js"
import style0 from "./NeedHelp.vue?vue&type=style&index=0&id=f25c2844&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports